import { CongressionalMember } from "./CongressionalCard";

// fmpName is the member's name exactly as FMP files it (middle names and
// initials included); FMP matches the by-name endpoints against that string.
export const congressionalMembers: CongressionalMember[] = [
  {
    name: "Nancy Pelosi",
    fmpName: "Nancy Pelosi",
    imageUrl: "/nancyPelosi.webp",
    isSenate: false, // House Representative (California)
  },
  {
    name: "David Rouzer",
    fmpName: "David Rouzer",
    imageUrl: "/davidRouzer.jpeg",
    isSenate: false, // House Representative (North Carolina)
  },
  {
    name: "Josh Gottheimer",
    fmpName: "Josh S. Gottheimer",
    imageUrl: "/joshGottheimer.jpeg",
    isSenate: false, // House Representative (New Jersey)
  },
  {
    name: "Michael McCaul",
    fmpName: "Michael T. McCaul",
    imageUrl: "/michaelMcCaul.jpg",
    isSenate: false, // House Representative (Texas)
  },
  {
    name: "Austin Scott",
    fmpName: "Austin Scott",
    imageUrl: "/austinScott.jpg",
    isSenate: false, // House Representative (Georgia)
  },
  {
    name: "Roger Williams",
    fmpName: "Roger Williams",
    imageUrl: "/rogerWilliams.jpg",
    isSenate: false, // House Representative (Texas)
  },
  {
    name: "Ron Wyden",
    fmpName: "Ronald Lee Wyden",
    imageUrl: "/ronWyden.jpeg",
    isSenate: true, // Senator (Oregon)
  },
  {
    name: "Tommy Tuberville",
    fmpName: "Thomas Hawley Tuberville",
    imageUrl: "/tommyTuberville.jpg",
    isSenate: true, // Senator (Alabama)
  },
  {
    name: "Marjorie Taylor Greene",
    fmpName: "Marjorie Taylor Greene",
    imageUrl: "/marjorieTaylorGreene.jpg",
    isSenate: false, // House Representative (Georgia)
  },
  {
    name: "Gilbert Cisneros",
    fmpName: "Gilbert Ray Cisneros",
    imageUrl: "/gilbertCisneros.jpeg",
    isSenate: false, // House Representative (California)
  },
  {
    name: "Ro Khanna",
    fmpName: "Ro Khanna",
    imageUrl: "/profile-photos/ro-khanna.jpg",
    isSenate: false,
  },
  {
    name: "Kevin Hern",
    fmpName: "Kevin Hern",
    imageUrl: "/profile-photos/kevin-hern.jpg",
    isSenate: false,
  },
  {
    name: "Tony Wied",
    fmpName: "Tony Wied",
    imageUrl: "/profile-photos/tony-wied.jpg",
    isSenate: false,
  },
  {
    name: "David Taylor",
    fmpName: "David J. Taylor",
    imageUrl: "/profile-photos/david-taylor.jpg",
    isSenate: false,
  },
  {
    name: "Jonathan Jackson",
    fmpName: "Jonathan Jackson",
    imageUrl: "/profile-photos/jonathan-jackson.jpg",
    isSenate: false,
  },
  {
    name: "Michael Rulli",
    fmpName: "Michael A. Rulli",
    imageUrl: "/profile-photos/michael-rulli.jpg",
    isSenate: false,
  },
  {
    name: "John McGuire",
    fmpName: "John J. McGuire",
    imageUrl: "/profile-photos/john-mcguire.jpg",
    isSenate: false,
  },
  {
    name: "Cleo Fields",
    fmpName: "Cleo Fields",
    imageUrl: "/profile-photos/cleo-fields.jpg",
    isSenate: false,
  },
  {
    name: "Jared Moskowitz",
    fmpName: "Jared Moskowitz",
    imageUrl: "/profile-photos/jared-moskowitz.jpg",
    isSenate: false,
  },
  {
    name: "Kelly Morrison",
    fmpName: "Kelly Morrison",
    imageUrl: "/profile-photos/kelly-morrison.jpg",
    isSenate: false,
  },
  {
    name: "Bill Keating",
    fmpName: "William R. Keating",
    imageUrl: "/profile-photos/bill-keating.jpg",
    isSenate: false,
  },
  {
    name: "Tim Moore",
    fmpName: "Tim Moore",
    imageUrl: "/profile-photos/tim-moore.jpg",
    isSenate: false,
  },
  {
    name: "Tom Kean Jr.",
    fmpName: "Thomas Kean",
    imageUrl: "/profile-photos/tom-kean-jr.jpg",
    isSenate: false,
  },
  {
    name: "Ed Case",
    fmpName: "Ed Case",
    imageUrl: "/profile-photos/ed-case.jpg",
    isSenate: false,
  },
  {
    name: "Rick Allen",
    fmpName: "Rick W. Allen",
    imageUrl: "/profile-photos/rick-allen.jpg",
    isSenate: false,
  },
  {
    name: "Rich McCormick",
    fmpName: "Rich McCormick",
    imageUrl: "/profile-photos/rich-mccormick.jpg",
    isSenate: false,
  },
  {
    name: "Michael Guest",
    fmpName: "Michael Guest",
    imageUrl: "/profile-photos/michael-guest.jpg",
    isSenate: false,
  },
  {
    name: "Sheldon Whitehouse",
    fmpName: "Sheldon Whitehouse",
    imageUrl: "/profile-photos/sheldon-whitehouse.jpg",
    isSenate: true,
  },
  {
    name: "Richard Blumenthal",
    fmpName: "Richard Blumenthal",
    imageUrl: "/profile-photos/richard-blumenthal.jpg",
    isSenate: true,
  },
  {
    name: "Dave McCormick",
    fmpName: "David Harold McCormick",
    imageUrl: "/profile-photos/dave-mccormick.jpg",
    isSenate: true,
  },
  {
    name: "John Boozman",
    fmpName: "John Boozman",
    imageUrl: "/profile-photos/john-boozman.jpg",
    isSenate: true,
  },
  {
    name: "John Fetterman",
    fmpName: "John Karl Fetterman",
    imageUrl: "/profile-photos/john-fetterman.jpg",
    isSenate: true,
  },
  {
    name: "Gary Peters",
    fmpName: "Gary C. Peters",
    imageUrl: "/profile-photos/gary-peters.jpg",
    isSenate: true,
  },
  {
    name: "Shelley Moore Capito",
    fmpName: "Shelley Moore Capito",
    imageUrl: "/profile-photos/shelley-moore-capito.jpg",
    isSenate: true,
  },
  {
    name: "Bernie Moreno",
    fmpName: "Bernardo Moreno",
    imageUrl: "/profile-photos/bernie-moreno.jpg",
    isSenate: true,
  },
];

// Utility function to create URL slug from name
export const createMemberSlug = (name: string): string => {
  return name.toLowerCase().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
};

// Utility function to find member by slug
export const findMemberBySlug = (slug: string): CongressionalMember | undefined => {
  return congressionalMembers.find(member => 
    createMemberSlug(member.name) === slug
  );
};